<div class="cp-grid-container custom-grid" [hidden]="isHidden">
    <se-floating-label
        [class.invisible]="!control.isWithLabel"
        [for]="control.id"
        [state]="isDisabled ? 'disabled' : 'active'"
        [tooltip]="control.name"
    >
        {{ control.name }}
    </se-floating-label>

    <ng-container *ngIf="tabGuardSwitch">
        <div style="font-size: 0" contenteditable="true" tabindex="0" #tabGuard></div>
    </ng-container>

    <form class="cp-grid-form" [formGroup]="formGroup" #gridContainer>
        <!-- Sono necessari 2 px per il bordo -->
        <ag-grid-angular
            style="width: 100%"
            #tabRef
            class="ag-theme-material"
            [style.height.px]="control.getHeight() - 2"
            [gridOptions]="gridOptions"
            [columnDefs]="columnDefs"
            [rowData]="model"
            [context]="getContext()"
            [overlayNoRowsTemplate]="noRowsTemplate"
            [components]="control.gridComponents"
            (gridReady)="onGridReady($event)"
            (columnResized)="_onColumnResized()"
            (gridSizeChanged)="_onGridSizeChanged($event)"
            (keydown.alt.enter)="_onAltEnter($event)"
            (cellEditingStopped)="_onCellEditingStopped($event)"
        >
        </ag-grid-angular>
        <div>
            <cp-additional-content
                *ngFor="let additionalContent of control.additionalContent"
                [control]="additionalContent"
                [cardId]="cardId"
                [disabled]="isDisabled"
                (edited)="_onChangeFromAdContent()"
            >
            </cp-additional-content>
        </div>
    </form>
</div>
